import cn from 'classnames';
import 'flag-icons/css/flag-icons.min.css';
import { assets } from '@round/whitelabel-ui';

const { EmptyLocationFlag: EmptyFlagIcon } = assets;

export type LocationFlagIconProps = {
    locationCode: string | null;
    isSquare?: boolean;
    className?: string;
};

const LocationFlagIcon = ({ locationCode, isSquare, className }: LocationFlagIconProps) => {
    return locationCode ? (
        <div className={cn(`fi fi-${locationCode.toLowerCase()}${isSquare ? ' fis' : ''}`, className)}></div>
    ) : (
        <EmptyFlagIcon />
    );
};

export default LocationFlagIcon;
